import React from 'react';
import PropTypes from 'prop-types';
import ConnectedTextField from 'shared/components/connectedTextField/ConnectedTextFieldConnector';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import { HARDCODED_TARGET_IMPORT } from 'shared/constants/SharedConstants';

class ImportDescriptionPanel extends React.PureComponent {  
  componentDidMount() {
    if(this.props.disabled) {
      this.props.targetFieldsActions.fetchTargetMappingSchemas(HARDCODED_TARGET_IMPORT);
    }
    else {
      this.props.targetFieldsActions.fetchInvoiceTargetMappingInformationById();
    }
  }
  
  destinationSchema = () => {
    const { profileTargetId, targetSchemas } = this.props;
    const targetResults = targetSchemas.find(schema => (schema.id === profileTargetId));
    if ( targetResults ) return targetResults.name;
  };
  
  render() {
    const { loading, disabled, profileTargetId } = this.props;
    return (
      <BootstrapCard 
        title="1. Name & Description" 
        width={ 600 } 
        loading={ loading } 
        disabled={ disabled } 
        margin={ '15px 0' } 
      >
        <ConnectedTextField name="name" label="Profile Name" required />
        <ConnectedTextField name="description" label="Description (Optional)" />
        <p style={ {marginTop: 25, fontSize: 16} }>
          Destination Schema:
          { 
            profileTargetId && ` ${ this.destinationSchema() }`
          }
          {
            !profileTargetId && ` INVOICE`
          } 
        </p>
      </BootstrapCard>
    );
  }
}

ImportDescriptionPanel.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  targetSchemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  profileTargetId: PropTypes.number,
  targetFieldsActions: PropTypes.shape({
    fetchTargetMappingSchemas: PropTypes.func,
    fetchInvoiceTargetMappingInformationById: PropTypes.func
  }).isRequired
};

ImportDescriptionPanel.defaultProps = {
  loading: false,
  disabled: false
};

export default ImportDescriptionPanel;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/importDescriptionPanel/ImportDescriptionPanel.js